import { render, staticRenderFns } from "./contract-mandatory-files.vue?vue&type=template&id=47a18a56"
import script from "./contract-mandatory-files.vue?vue&type=script&lang=js"
export * from "./contract-mandatory-files.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports